import React, { useContext } from 'react'
import styled from 'styled-components/macro'
import LOGO_MOMCOM_WHITE from '../../statics/images/logo-momcom-white.svg'
import { MEDIA, COLORS, PADDINGS, PAGE_WIDTHS, FONT_FAMILIES } from '../../utils/styles'
import { DetectDeviceContext } from 'wsc/components/context/DetectDeviceProvider'
import FooterSocial from './FooterSocial'
import FooterContact from './FooterContact'
import FooterProduct from './FooterProduct'

const ScWrapper = styled.div`
  position: relative;
  text-align: center;
  padding: 50px 0 150px;
  background: ${COLORS.TWILIGHT_BLUE};
  ${MEDIA.MOBILE`
    padding: 40px 0 140px;
  `}

  ${MEDIA.DESKTOP`
    .takeover-active & {
      width: calc(100% + 40px);
      left: unset;
      right: unset;
      margin-left: -20px;
      margin-right: unset;
    }
  `}
`

const ScContainer = styled.div`
  margin: 0 auto;
  ${MEDIA.MOBILE`
    padding-left: ${PADDINGS.DEFAULT.MOBILE}px;
    padding-right: ${PADDINGS.DEFAULT.MOBILE}px;
  `}
  ${MEDIA.TABLET`width: ${PAGE_WIDTHS.TABLET}px;`}
  ${MEDIA.DESKTOP`
    width: ${PAGE_WIDTHS.DESKTOP}px;
    .takeover-active & {
      width: 100%;
      padding: 0 20px;
    }
  `}
`

const ScLogoImg = styled.img`
  height: 45px;
`

const ScTitle = styled.div`
  color: ${COLORS.WHITE};
  font-family: ${FONT_FAMILIES.SERIF};
  font-size: 0.94rem;
  line-height: 1.59rem;
  padding-top: 10px;
  margin-top: 10px;
  ${MEDIA.MOBILE`
    padding-top: 14px;
    font-size: 1rem;
    line-height: 1.7rem;
    margin-top: 0px;
  `}

  ${MEDIA.TABLET`
    font-size: 0.95rem;
    line-height: 1.61rem;
    margin-top: 10px;
  `}
`

const ScSeparator = styled.hr`
  width: 100%;

  margin: 30px 0;

  ${MEDIA.TABLET`
    margin: 30px 0 50px 0;
  `}

  ${MEDIA.DESKTOP`
    margin: 30px 0;
  `};
`

const ScUnderSeparatorDiv = styled.div.attrs({
  className: 'font-description',
})`
  color: ${COLORS.WHITE};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  font-size: 0.79rem;
  line-height: 1.34rem;
  letter-spacing: 0.05rem;

  ${MEDIA.TABLET`
    font-size: 0.76rem;
    line-height: 1.29rem;
  `}

  ${MEDIA.DESKTOP`
    font-size: 0.71rem;
    line-height: 1.19rem;
    letter-spacing: 0.04rem;
  `}
`

const ScCorpDetail = styled.div`
  flex-grow: 1;
  text-align: center;
  ${MEDIA.MOBILE`
    flex-basis: 100%;
  `}
  ${MEDIA.DESKTOP`
    text-align: right;
  `}
  ${props => props.order && `order: ${props.order};`}
`

const ScParentCompany = styled(ScCorpDetail)`
  font-weight: bold;
  margin-top: 1.5rem;
  text-align: center;

  ${MEDIA.DESKTOP`
    margin-top: .75rem;
    text-align: center;
  `}
`

/*----------------------------------------------------------------------------------
 *  RENDER PHASE
 *---------------------------------------------------------------------------------*/

const Footer = () => {
  const { isDesktop, isMobile_S } = useContext(DetectDeviceContext)
  const currentYear = new Date().getFullYear()
  return (
    <ScWrapper>
      <ScContainer>
        {/* MOM.COM icon */}
        <ScLogoImg src={LOGO_MOMCOM_WHITE} />

        {/* Title */}
        <ScTitle>Empower Her. Be Her Village. Shape{isMobile_S ? <br /> : ' '}the World.</ScTitle>

        {/* Social button */}
        <FooterSocial />

        {/* Seperator */}
        <ScSeparator />

        <ScUnderSeparatorDiv>
          {/* Contact link list */}
          <FooterContact />

          {/* Wild Sky Media corperation detail*/}
          <ScCorpDetail order={2}>
            © {currentYear} WILD SKY MEDIA.{isMobile_S ? <br /> : ' '}ALL RIGHTS RESERVED.
          </ScCorpDetail>
          <ScCorpDetail order={isDesktop ? 4 : 3}>
            PART OF WILD SKY MEDIA {isMobile_S ? <br /> : '|'} FAMILY & PARENTING
          </ScCorpDetail>

          {/* All Product link */}
          <FooterProduct />

          {/* Ownership Disclosure */}
          <ScParentCompany order={5}>
            This site is owned and operated by Bright Mountain Media, Inc., a publicly owned company
            trading with the symbol: BMTM.
          </ScParentCompany>
        </ScUnderSeparatorDiv>
      </ScContainer>
    </ScWrapper>
  )
}

Footer.propTypes = {}

Footer.defaultProps = {}

export default Footer
